import { AxiosInstance } from 'axios';
import { BaseServiceClient } from './BaseServiceClient';

export interface ServiceClientOptions {
  axiosInstance: AxiosInstance;
  serviceName: string;
  host: string;
}

export default class ServiceClient extends BaseServiceClient {
  constructor({ axiosInstance, host, serviceName }: ServiceClientOptions) {
    super(axiosInstance, `${host}/${serviceName}`);
  }
}
